/**
 * The lat/long text format of the Go to Location dialog's Coords tab, shared with
 * every "copy coordinates" action so a copied point pastes straight back into it.
 *
 * Latitude comes first. Pasting `lng, lat` into the dialog doesn't fail — both
 * values are usually in latitude range — it silently flies somewhere else.
 */

export interface LatLon {
  lat: number;
  lng: number;
}

/** `lat, lng` to 6 decimal places (~0.1 m), e.g. `53.349805, -6.260310`. */
export function formatGoToLocationLatLon(lat: number, lng: number): string {
  return `${Number(lat).toFixed(6)}, ${Number(lng).toFixed(6)}`;
}

/**
 * Read `lat lng`, `lat, lng` or `lat,lng` as the Go to Location dialog does, or
 * null when it isn't a valid position.
 */
export function parseGoToLocationLatLon(input: string): LatLon | null {
  const parts = input.replace(/,/g, ' ').trim().split(/\s+/);
  if (parts.length < 2) return null;

  const lat = parseFloat(parts[0]);
  const lng = parseFloat(parts[1]);
  if (Number.isNaN(lat) || Number.isNaN(lng)) return null;
  if (lat < -90 || lat > 90 || lng < -180 || lng > 180) return null;

  return { lat, lng };
}
